// api/client.ts - Fixed version
import axios from 'axios';
import { API_CONFIG } from '@/config';

// Create the API client
export const api = axios.create({
    baseURL: API_CONFIG.BASE_URL,
    timeout: API_CONFIG.TIMEOUT,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add request interceptor (without auth if not needed)
api.interceptors.request.use(
    (config) => {
        // Remove auth logic if you don't have authentication
        // const token = localStorage.getItem('token');
        // if (token) {
        //     config.headers.Authorization = `Bearer ${token}`;
        // }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Handle unauthorized
            localStorage.removeItem('token');
            // Optionally redirect to login
        }
        return Promise.reject(error);
    }
);